import { Field, Input, Select } from '@/components/field'
import { useDraft } from '@/features/back-office/use-draft'
import { useLanguage } from '@/lib/i18n/store'
import { useT } from '@/lib/i18n/translate'
import { monthNames } from '@/lib/time'

/** Month select and year input; `onChange` fires with `YYYY-MM` once both are whole. */
export function MonthPicker({ month, onChange }: { month: string; onChange: (month: string) => void }) {
  const t = useT()
  const language = useLanguage()
  const [year, setYear] = useDraft(month.slice(0, 4))
  const names = monthNames(language)
  const go = (y: string, m: string) => /^\d{4}$/.test(y) && onChange(`${y}-${m}`)
  return (
    <div className="flex flex-wrap items-end gap-2">
      <Field label={t('stats.month')} className="w-44">
        <Select value={month.slice(5, 7)} onChange={(event) => go(year, event.target.value)}>
          {names.map((name, index) => (
            <option key={name} value={String(index + 1).padStart(2, '0')}>
              {name}
            </option>
          ))}
        </Select>
      </Field>
      <Field label={t('stats.year')} className="w-28">
        <Input
          type="number"
          inputMode="numeric"
          min={2000}
          max={2100}
          step={1}
          value={year}
          onChange={(event) => {
            setYear(event.target.value)
            go(event.target.value, month.slice(5, 7))
          }}
        />
      </Field>
    </div>
  )
}
